import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// No backend yet — redirect to doctors page
// When backend is ready, replace this with the full booking flow

const BookingFlow = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/doctor/${id}`);
  }, [id, navigate]);

  return null;
};

export default BookingFlow;